import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { monitoringApi, HistoryItem, MonitoringApiError, HistoryParams } from '../../../../services/monitoringApi';

export default function useMonitoringHistory(personId: string | null) {
    const [items, setItems] = useState<HistoryItem[]>([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(20);
    const [isLoading, setIsLoading] = useState(false);

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [hasDivergence, setHasDivergence] = useState<boolean | undefined>(undefined);

    const fetchData = useCallback(async () => {
        if (!personId) return;
        setIsLoading(true);
        try {
            const params: HistoryParams = {
                page,
                pageSize,
                document: personId,
                dateFrom: dateFrom || undefined,
                dateTo: dateTo || undefined,
                hasDivergence,
            };
            const result = await monitoringApi.getHistory(params);
            setItems(result.data?.items || []);
            setTotal(result.data?.total || 0);
        } catch (e: unknown) {
            if (e instanceof MonitoringApiError) {
                toast.error(e.message);
            } else {
                toast.error('Erro ao carregar histórico');
            }
            setItems([]);
            setTotal(0);
        } finally {
            setIsLoading(false);
        }
    }, [personId, page, pageSize, dateFrom, dateTo, hasDivergence]);

    useEffect(() => {
        if (personId) {
            setPage(1);
            setItems([]);
        }
    }, [personId]);

    useEffect(() => { fetchData(); }, [fetchData]);

    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    return {
        items,
        total,
        page,
        setPage,
        pageSize,
        totalPages,
        isLoading,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
        hasDivergence,
        setHasDivergence,
    };
}
